import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useResponsive } from '../hooks/useResponsive';

export interface ResponsiveContextType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const ResponsiveContext = createContext<ResponsiveContextType>({
  isMobile: false,
  isTablet: false,
  isDesktop: false
});

export const ResponsiveProvider = ({ children }: { children: ReactNode }) => {
  const responsive = useResponsive();

  return (
    <ResponsiveContext.Provider value={responsive}>
      {children}
    </ResponsiveContext.Provider>
  );
};

/**
 * Hook to access the responsive context
 * @throws {Error} If used outside of ResponsiveProvider
 */
export const useResponsiveContext = (): ResponsiveContextType => {
  const context = useContext(ResponsiveContext);
  if (context === undefined) {
    throw new Error('useResponsiveContext must be used within a ResponsiveProvider');
  }
  return context;
};
